// non-palette design tokens usable outside the MUI theme.
//
// Keep the JetBrains Mono font that ships in index.html at the head of the
// stack. Consumers import this instead of typing the stack inline.

export const MONO_FONT_STACK =
  '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace';
